import { HttpErrorResponse } from '@angular/common/http';

/**
 * The compile endpoints return the reason as the response body (a bare JSON
 * string, or an object carrying `message`). Surface it so the user sees *why*
 * the automatic compilation was refused — e.g. no documents uploaded yet —
 * instead of a generic failure toast.
 */
export function extractApiMessage(err: unknown): string | null {
  if (!(err instanceof HttpErrorResponse)) return null;

  const body: unknown = err.error;
  if (typeof body === 'string' && body.trim() !== '') return body;

  if (body && typeof body === 'object') {
    const message = (body as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim() !== '') return message;
  }

  return null;
}
